<!-- La hoja es una <table> por su modelo de fragmentación de impresión: el
     <tfoot> se repite al final de CADA página y reserva el lugar del pie;
     el pie visible es el elemento fijo de abajo, que en medios paginados se
     pinta al pie de todas las páginas, con cualquier papel y márgenes. -->
<table class="hoja">
  <tbody>
    <tr>
      <td class="hoja__celda-cuerpo">
        <div class="hoja__cuerpo">
          <p class="hoja__fecha">{{ fecha() }}</p>

          <!-- Encabezado: broker titular + contacto, con el subrayado degradé.
               En los links compartidos de una alianza (#17) queda sólo el
               subrayado: sin logo, nombre ni contacto del broker. -->
          <header class="hoja__encabezado">
            @if (ocultarContacto()) {
              <span></span>
            } @else if (logo(); as logoUrl) {
              <img
                class="hoja__logo-broker"
                [src]="logoUrl"
                [alt]="nombreContacto() ?? 'Inmobiliaria'"
                (error)="ocultarRota($event)"
              />
            } @else if (nombreContacto(); as nombre) {
              <span class="hoja__nombre-broker">{{ nombre }}</span>
            } @else {
              <span></span>
            }

            @if (!ocultarContacto() && whatsapp(); as telefono) {
              <div class="hoja__contacto">
                <span class="hoja__wa">
                  <svg app-icono nombre="whatsapp"></svg>
                </span>
                <div class="hoja__contacto-datos">
                  <span class="hoja__telefono">{{ telefono }}</span>
                  <!-- La inmobiliaria (o su broker) acompaña al teléfono -->
                  @if (nombreContacto(); as nombre) {
                    <span class="hoja__agente">{{ nombre }}</span>
                  }
                </div>
              </div>
            }
          </header>

          <div class="hoja__detalle">
            <!-- Localidad + operación | precio -->
            <div class="hoja__titulo">
              <div class="hoja__ubicacion">
                <span class="hoja__localidad">{{ propiedad().localidad }}</span>
                <span class="hoja__operacion">{{ operacion() }}</span>
              </div>
              <div class="hoja__precios">
                @if (precioVenta(); as venta) {
                  <span class="hoja__precio">{{ venta }}</span>
                }
                @if (precioAlquiler(); as alquiler) {
                  <span class="hoja__precio">{{ alquiler }} /mes</span>
                }
                @if (!precioVenta() && !precioAlquiler()) {
                  <span class="hoja__precio">Consultar</span>
                }
              </div>
            </div>

            <!-- Galería: portada + grilla 2×2 (máx. 5 fotos, como la ficha) -->
            @if (fotoPrincipal(); as portada) {
              <div class="hoja__galeria">
                <div class="hoja__foto">
                  <img [src]="portada" alt="" (error)="ocultarRota($event)" />
                </div>
                <div class="hoja__grilla">
                  @for (foto of fotosGrilla(); track $index) {
                    <div class="hoja__foto">
                      @if (foto) {
                        <img [src]="foto" alt="" (error)="ocultarRota($event)" />
                      }
                    </div>
                  }
                </div>
              </div>
            }

            <!-- Datos (columna fija de 97pt) + descripción -->
            <div class="hoja__info">
              <div class="hoja__datos">
                @if (propiedad().superficie != null) {
                  <div class="hoja__dato">
                    <span class="hoja__etiqueta">Mt2</span>
                    <span class="hoja__valor">{{ propiedad().superficie }}</span>
                  </div>
                }
                @if (propiedad().ambientes != null) {
                  <div class="hoja__dato">
                    <span class="hoja__etiqueta">Ambientes</span>
                    <span class="hoja__valor">{{ propiedad().ambientes }}</span>
                  </div>
                }
                @if (propiedad().dormitorios != null) {
                  <div class="hoja__dato">
                    <span class="hoja__etiqueta">Dormitorios</span>
                    <span class="hoja__valor">{{ propiedad().dormitorios }}</span>
                  </div>
                }
                <div class="hoja__dato">
                  <span class="hoja__etiqueta">Zona</span>
                  <span class="hoja__valor">{{ direccion() }}</span>
                </div>
              </div>

              <div class="hoja__descripcion">
                <span class="hoja__etiqueta">Descripción</span>
                <p class="hoja__texto">{{ propiedad().descripcion || 'Sin descripción.' }}</p>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td class="hoja__celda-pie">
        <!-- Espaciador invisible: al repetirse el tfoot, reserva el lugar del
             pie al final de CADA página para que el contenido no lo pise. -->
        <footer class="hoja__pie hoja__pie--espaciador" aria-hidden="true">
          <span>© {{ anio }} Phindi - Todos los derechos reservados.</span>
          <img class="hoja__logo-phindi" src="/logos/logo-rose-500.svg" alt="" />
        </footer>
      </td>
    </tr>
  </tfoot>
</table>

<!-- Pie real: fijo, en medios paginados se pinta al pie de CADA página, con
     cualquier papel y márgenes que elija el diálogo de impresión. -->
<footer class="hoja__pie hoja__pie--fijo">
  <span>© {{ anio }} Phindi - Todos los derechos reservados.</span>
  <img class="hoja__logo-phindi" src="/logos/logo-rose-500.svg" alt="Phindi" />
</footer>
